<template>
   <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Input Pengiriman {{this.$route.params.ref}}</h3>
        <div class="ml-auto">
          <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
           Batal
          </vs-button>
        </div> 
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
            <b>Terdapat Kesalahan..</b>
            <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </vs-alert>
          <div>
          <vs-row>
            <vs-col vs-lg="6" vs-xs="12" vs-sm="4">  
                <vs-input label="NO RESI" ref="no_resi" class="w-100 mt-4" v-model="formdata.no_kirim"/>  
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="4"></vs-col>
          </vs-row>
          <br/>
          <vs-row>
              <vs-col vs-lg="6" vs-xs="12" vs-sm="4"><h3>Daftar barang yang harus diterima..</h3></vs-col>
          </vs-row>
          <JqxGrid ref="myGrid" :autorowheight="true" :autoheight="true"
            :width="width" :theme="'material-green'" :selectionmode="'singlerow'" 
            :pageable="true" :sortable="true" :filterable="true" :showfilterrow="true" :columnsresize="true"
            :source="dataAdapter" :columns="columns" 
          />
        </div>
        <hr class="custom-hr" />
        
      </vs-card>
    </vs-col>
    
   </vs-row>
</template>

<script>
  import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
  import _debounce from 'lodash/debounce';

  export default {
    components: {
      JqxGrid,
    },
    
    data: function () {
      return {
        // eslint-disable-next-line
        dataAdapter: new jqx.dataAdapter(this.source, {
            formatData: function (data) {
                return  JSON.stringify(data);
            },
            beforeSend: function (jqxhr, settings) { 
                settings.xhrFields = {
                    withCredentials: true
                },
                jqxhr.setRequestHeader("X-XSRF-TOKEN",window.$cookies.get('XSRF-TOKEN'))
            }
        }),
        width: "100%",
        columns: [
          { text: 'Tgl', datafield: 'kirim_tgl', filtertype: 'range', width: '10%', cellsformat: 'dd-MM-yyyy' },
          { text: 'No Resi', datafield: 'kirim_no', width: '15%' },
          { text: 'Nama Pengirim', datafield: 'nama_pengirim', width: '10%'},
          { text: 'Asal', filtertype: 'list', filteritems: this.items, datafield: 'kab_asal', width: '15%'},
          { text: 'CASH / COD', filtertype: 'list', filteritems: this.items, datafield: 'bayar', width: '10%'},
          { text: 'Kabupaten Tujuan', filtertype: 'list', filteritems: this.items, datafield: 'kab_id', width: '10%'},
          { text: 'Kecamatan Tujuan', filtertype: 'list', filteritems: this.items, datafield: 'kec_id', width: '10%'},
          { text: 'Status', filtertype: 'list', filteritems: this.items, datafield: 'status', width: '20%'},
        ],
        selectrow: 0,
        formdata: {
            no_kirim:'',
            office_id:this.$store.getters.getOffice,
            opr:'',
            datatrans:[],
            isEdit: false,
            prevReferensi:'',
            po_no:'',
            sj_no:''
        },
        optpropinsi:[],
        optkabupaten:[],
        optkecamatan:[],
        optproduk:[{'kode':'REG','nama':'REGULER'},{'kode':'EXP','nama':'EXPRESS'}],
        kelompok:'',
        jenis:'',
        barang:'',
        satuan:'',
        qty:'',
        catatan:'',
        dk:true,
        transval:'',
        errors:[],
        errorPerkiraan:false,
        errorBarang:false,
        errorQty:false,
        numSumDebet:0,
        numSumKredit:0,
        idtrans:0,
        
        //formatTgl:''
      }
    },
    methods:{
        backpage: function(){
            this.$router.go(-1);
        },
        scanBarcode:function(e) {
            if(this.formdata.no_kirim != ''){
                this.errors = []
                this.$vs.loading({'type':'radius'})
                this.$http.post('/api/kirimtransit',{
                    formdata : this.formdata
                }).then(response => {
                    console.log(response);
                    this.handleSuccess();
                    //
                }).catch(error=>{
                    console.log(error)
                    this.formdata.no_kirim = ''
                    this.handleError(error)
                })
            }
        },
        handleError: function(error,type=''){
            if(type != 'local'){
                if (error.response != null){
                    let status = error.response.status
                    console.log(status)
                    switch(status){
                        case 422 :
                            const keys = Object.keys(error.response.data.errors)
                            //console.log(keys);
                            for(const key of keys){
                                //console.log(key)
                                //console.log(error.response.data.errors[key][0])
                                this.errors.push(error.response.data.errors[key][0])
                            }
                        break
                        case 500 :
                            this.errors.push('Internal server error.. silahkan hubungi administrator')
                            break
                        default:
                            break
                    }
                }
            }
            console.log('handle error')
            this.notify()
            this.$vs.loading.close()
        },
        handleSuccess: function(){
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
            //this.$router.push('/jurnal/ju');
            this.formdata.no_kirim = ""
            this.$refs.myGrid.updatebounddata();
            this.formdata.no_kirim = ''
        },
        notify: function(){
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:()=>{
                    window.scrollTo(0,0);
                },
            })
        }
    },
    beforeCreate: function () {
      this.source = {
        datafields: [
          { name: 'kirim_no', type: 'string'},
          { name: 'kirim_tgl', type: 'date'},
          { name: 'nama_pengirim', type: 'string'},
          { name: 'alamat_penerima', type: 'string'},
          { name: 'bayar', type: 'string'},
          { name: 'kab_asal', map: 'kab_nama'},
          { name: 'kab_id', map: 'dkab_nama'},
          { name: 'kec_id', map: 'dkec_nama'},
          { name: 'leadtime', type: 'date'},
          { name: 'status', map: 'status_name'},
        ],
        datatype: 'json',
        id: 'referensi',
        url: this.$urlbackend+'/api/daftartransit',
        type: 'post',
        deleterow: function (rowid, commit) {
            commit(true);
        }
      }
      this.editrow = -1;
    },
    created: function() {
        this.scanBarcode = _debounce(this.scanBarcode, 300)
    },
    computed: {
        options () {
            return {
                locale: this.locale,
                currency: this.currency
            }
        }
    },
    watch:{
        'formdata.no_kirim': function(){
            this.scanBarcode();
        },
    },
    
  }
</script>
<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>